/** className for SidebarProvider in SidebarShellLayout (relative positioning in shell). */
export const SIDEBAR_SHELL_PROVIDER_CLASSES = "[&_[data-slot=sidebar-container]]:relative";
